import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { setCurrentModal, toggleModal } from "@/store/slices/GlobalSlice";
import BtnGreen from "../BtnGreen";

const TownHeading = (props) => {
  const dispatch = useDispatch();

  const handleWinPrize = () => {
    dispatch(setCurrentModal("prize"));
    dispatch(toggleModal());
  };

  const handleShare = () => {
    dispatch(toggleModal());
    dispatch(setCurrentModal("formWrapper"));
  };

  return (
    <div className="text-center mb-10 md:mb-7">
      <h2 className="text-40 font-semibold text-white leading-45 mb-7 md:mb-0">
        Singapore’s Greenest Home Town
      </h2>

      <h3 className="text-3xl font-semibold text-white mb-6 md:mb-5">
        Put your home and ‘hood on the map!
      </h3>

      <div className="text-lg text-white max-w-3xl mx-auto mb-8 md:pb-5">
        Our homeowners went to town with ‘greening’ up their home to find
        Singapore’s Greenest Town. See what amazing actions they’ve made to
        build green into their home!
      </div>

      {/* <div className="pb-5 md:pb-20">
        <BtnGreen
          className="border border-solid border-white"
          onClick={handleShare}
        >
          <span className="text-lg md:text-2xl">Share your Green Home</span>
          <span className="ml-5 mt-1">
            <img src={require("@/assets/images/right-arrow.png")} alt="icon" />
          </span>
        </BtnGreen>
      </div> */}

      {/* <div
        className="md:hidden bg-sgbc-orange-300 text-sgbc-blue-900 text-15 font-bold cursor-pointer py-4 px-8 rounded-full uppercase inline-flex items-center justify-center"
        onClick={handleWinPrize}
      >
        Win prizes for your home!
      </div> */}
    </div>
  );
};

TownHeading.propTypes = {};

export default TownHeading;
